// general imports
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getExceptionPayload } from '../../../lib/utils/get-exception-payload'

import { ApprovalRequestsService } from '../../../services/api/super-admin/approval-requests/approval-requests.service'
import { ApiRequestErrorType } from '../../../types/api/api.types'
import {
  ApproveIndividualRequestType,
  ApproveOrganizationRequestType,
  GetApprovalRequestType,
} from '../../../types/approve-request.type'

const approvalRequestsService = new ApprovalRequestsService()

export const getApprovalRequestsThunk = createAsyncThunk(
  '/auth/users/suspended-and-inactive',
  async (data: GetApprovalRequestType, { rejectWithValue }) => {
    try {
      const response = await approvalRequestsService.getApprovalRequests(data)
      return response?.data
    } catch (ex) {
      return rejectWithValue(getExceptionPayload(ex) as ApiRequestErrorType)
    }
  },
)
export const approveOrganizationRequestThunk = createAsyncThunk(
  'auth/validate/org-request',
  async (data: ApproveOrganizationRequestType, { rejectWithValue }) => {
    try {
      const response = await approvalRequestsService.approveOrganizationRequest(data)

      return response?.data
    } catch (ex) {
      return rejectWithValue(getExceptionPayload(ex) as ApiRequestErrorType)
    }
  },
)

export const approveIndividualRequestThunk = createAsyncThunk(
  '/auth/users/activate-user-account',
  async (data: ApproveIndividualRequestType, { rejectWithValue }) => {
    try {
      const response = await approvalRequestsService.approveIndividualRequest(data)

      return response?.data
    } catch (ex) {
      return rejectWithValue(getExceptionPayload(ex) as ApiRequestErrorType)
    }
  },
)
